import React, { useState, useEffect, useCallback } from 'react';
import {
  Table, Button, Space, Input, Card, Typography, message,
  Row, Col, Tooltip, Popconfirm,
} from 'antd';
import {
  PlusOutlined, EditOutlined, DeleteOutlined, PhoneOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../../api/axios';

const { Title } = Typography;
const { Search } = Input;

const AramaListe = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate();

  const fetchData = useCallback(async (q = '') => {
    setLoading(true);
    try {
      const url = q ? `/aramalar?q=${encodeURIComponent(q)}` : '/aramalar';
      const res = await api.get(url);
      const arr = Array.isArray(res.data) ? res.data : res.data.data || [];
      setData(arr);
    } catch {
      message.error('Arama kayıtları yüklenemedi');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(searchText);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchText, fetchData]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/aramalar/${id}`);
      message.success('Kayıt silindi');
      fetchData(searchText);
    } catch {
      message.error('Silme başarısız');
    }
  };

  const columns = [
    {
      title: 'Arayan Adı',
      dataIndex: 'arayanAdi',
      key: 'arayanAdi',
      render: (t) => <strong>{t || '-'}</strong>,
      sorter: (a, b) => (a.arayanAdi || '').localeCompare(b.arayanAdi || ''),
    },
    {
      title: 'Telefon',
      dataIndex: 'telefon',
      key: 'telefon',
    },
    {
      title: 'Arama Sebebi',
      dataIndex: 'aramaSebebi',
      key: 'aramaSebebi',
      ellipsis: true,
      width: 280,
    },
    {
      title: 'Tarih',
      dataIndex: 'tarih',
      key: 'tarih',
      render: (v) => v ? dayjs(v).format('DD.MM.YYYY') : '-',
      sorter: (a, b) => dayjs(a.tarih).unix() - dayjs(b.tarih).unix(),
    },
    {
      title: 'Oluşturan',
      dataIndex: 'olusturanKullanici',
      key: 'olusturanKullanici',
      render: (v) => v || '-',
    },
    {
      title: 'İşlemler',
      key: 'actions',
      fixed: 'right',
      width: 100,
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title="Düzenle">
            <Button
              type="primary"
              ghost
              size="small"
              icon={<EditOutlined />}
              onClick={() => navigate(`/aramalar/${record.id}/duzenle`)}
            />
          </Tooltip>
          <Tooltip title="Sil">
            <Popconfirm
              title="Bu kaydı silmek istediğinizden emin misiniz?"
              onConfirm={() => handleDelete(record.id)}
              okText="Evet"
              cancelText="Hayır"
            >
              <Button danger size="small" icon={<DeleteOutlined />} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Space>
            <PhoneOutlined style={{ fontSize: 20, color: '#1677ff' }} />
            <Title level={4} style={{ margin: 0 }}>Arama Kayıtları</Title>
          </Space>
        </Col>
        <Col>
          <Space>
            <Search
              placeholder="Ad, telefon veya sebep ara..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
              style={{ width: 260 }}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/aramalar/yeni')}
            >
              Yeni Kayıt
            </Button>
          </Space>
        </Col>
      </Row>

      <Card className="content-card" bodyStyle={{ padding: 0 }}>
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          bordered
          size="middle"
          scroll={{ x: 700 }}
          pagination={{
            pageSize: 15,
            showTotal: (t) => `Toplam ${t} kayıt`,
            showSizeChanger: true,
          }}
          locale={{ emptyText: 'Arama kaydı bulunamadı' }}
        />
      </Card>
    </div>
  );
};

export default AramaListe;
